import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ModuleDeleteService } from '../../services';

export const fetchModuleDelete = createAsyncThunk(
    'moduleDelete/fetchModuleDelete',
    async ({ id }) => {
        const response = await ModuleDeleteService(id)
        return response.result
    }
)

const moduleDeleteSlice = createSlice({
    name: 'moduleDelete',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchModuleDelete.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchModuleDelete.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchModuleDelete.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default moduleDeleteSlice.reducer;
